import React from 'react';
import { Paper, Grid, Typography, Box, TextField, Button, Tooltip } from '@material-ui/core';
import FlashOnIcon from '@material-ui/icons/FlashOn';

// En-tête de semaine : sélecteur de semaine, raccourci "semaine type" et compteur total
export default function WeekHeader({ classes, isMobile, weekString, onChangeWeek, monday, sunday, isLocked, totalSemaine, onAppliquerSemaineType, statutLabel }) {
    return (
        <>
            <Paper className={classes.headerCard}>
                <Grid container justify={isMobile ? 'center' : 'space-between'} alignItems="center">
                    <Grid item xs={12} sm={8} style={{ textAlign: isMobile ? 'center' : 'left' }}>
                        <Typography variant="h5" style={{ fontWeight: 800, color: '#1a202c', marginBottom: 8 }}>Relevé d'heures</Typography>
                        <Typography variant="subtitle1" color="textSecondary">
                            Du <b>{monday.toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })}</b> au <b>{sunday.toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' })}</b>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} style={{ textAlign: isMobile ? 'center' : 'right', marginTop: isMobile ? 12 : 0 }}>
                        {statutLabel}
                    </Grid>
                </Grid>

                <Box mt={3} display="flex" flexWrap="wrap" gap={2} alignItems="center" justifyContent={isMobile ? 'center' : 'space-between'}>
                    <Box flexGrow={1} minWidth={220}>
                        <TextField
                            type="week"
                            label="Sélectionnez la semaine"
                            value={weekString}
                            onChange={e => onChangeWeek(e.target.value)}
                            variant="outlined"
                            fullWidth
                            className={classes.inputRounded}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Box>
                    {!isLocked && (
                        <Tooltip title="Remplir 08:30 - 17:30 (Pause 1h) du Lundi au Vendredi">
                            <Button
                                variant="outlined"
                                color="primary"
                                startIcon={<FlashOnIcon />}
                                onClick={onAppliquerSemaineType}
                                style={{ borderRadius: 12, height: 48, textTransform: 'none', fontWeight: 600 }}
                            >
                                Semaine type (8h/j)
                            </Button>
                        </Tooltip>
                    )}
                </Box>
            </Paper>

            <Box mb={3} textAlign="center">
                <Typography variant="h3" style={{ fontWeight: 900, color: '#2b6cb0' }}>
                    {totalSemaine} <span style={{ fontSize: '1.5rem', color: '#718096' }}>/ 39h</span>
                </Typography>
            </Box>
        </>
    );
}
